import { gql } from '@apollo/client';

export const GET_IS_ORDER_MODAL_SHOWN = gql`
  query GetIsOrderModalShown {
    order @client {
      isOrderModalShown
    }
  }
`;
